export const IMAGE_TYPE = {
  LOGO: 1,
  SIGNATURE: 2,
};
